import { RenderingDetails } from "@swiggy-private/cart-types";
import { RawApiResponse } from "@swiggy-private/js-utils/dist/fetch/types";

export interface ICBCCNudge {
    setCroutonVisibility: (croutonVisibility: boolean) => void;
    itemData: RenderingDetails;
    applicableDiscount?: number;
    recordCbccInterest?: () => Promise<RawApiResponse>;
    impressionCbccNudge: (dv: string, bi: string) => void;
    clickCbccNudge: (dv: string, bi: string) => void;
    impressionCbccThankyouCrouton: (bi: string) => void;
    impressionCbccResponseReceived: (bi: string) => void;
    updateFrequencyCount: (cappingMode: CappingModes, entityId: string, entityType: string) => void;
    logClevertapEvent: (eventName: string, params: Record<string, string>) => void;
}

export enum CappingModes {
    VIEW = "VIEW",
    CLICK = "CLICK",
}

export interface IBannerDataFrequencyCapping {
    cappingEnabled: boolean;
    cappingMode: CappingModes;
}

export interface IBannerDataWidgetData {
    preClickHeading: string;
    preClickCtaText: string;
    preClickBellIconId: string;
    preClickBackground: string;
    postClickBackground: string;
    cardImageId: string;
    postClickSuccessText: string;
    postClickHeading: string;
    postClickCheckIconId: string;
    croutonSuccessText: string;
    croutonErrorText: string;
    entityType: string;
}

export interface IBannerData {
    bannerId: string;
    frequencyCapping: IBannerDataFrequencyCapping;
    widgetData: IBannerDataWidgetData;
}
